import AuthenticatedUserCustomer from './AuthenticatedUserCustomer';

export enum Language {
	cs = 'cs',
	sk = 'sk',
	en = 'en',
}

export default class AuthenticatedUser {
	id: string;

	email: string;

	name: string;

	language: Language;

	customer: AuthenticatedUserCustomer;

	constructor(id: string, email: string, name: string, language: Language, customer: AuthenticatedUserCustomer) {
		this.id = id;
		this.email = email;
		this.name = name;
		this.language = language;
		this.customer = customer;
	}
}
